// Drawing App - Export Manager (PNG/SVG)

import { CanvasEngine } from './canvas_engine';
import { LayerManager } from './layer_manager';

export class ExportManager {
  private canvasEngine: CanvasEngine;
  private layerManager: LayerManager;

  constructor(canvasEngine: CanvasEngine, layerManager: LayerManager) {
    this.canvasEngine = canvasEngine;
    this.layerManager = layerManager;
  }

  exportPNG(filename?: string): void {
    const compositeCanvas = this.canvasEngine.getCompositeImage();

    compositeCanvas.toBlob((blob) => {
      if (!blob) return;
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename || `drawing-${Date.now()}.png`;
      a.click();
      URL.revokeObjectURL(url);
    }, 'image/png');
  }

  exportPNGBlob(): Promise<Blob> {
    return new Promise((resolve, reject) => {
      const compositeCanvas = this.canvasEngine.getCompositeImage();
      compositeCanvas.toBlob((blob) => {
        if (blob) resolve(blob);
        else reject(new Error('Failed to create PNG blob'));
      }, 'image/png');
    });
  }

  exportSVG(): string {
    const { width, height } = this.canvasEngine.getCanvasSize();
    const compositeCanvas = this.canvasEngine.getCompositeImage();
    const dataURL = compositeCanvas.toDataURL('image/png');

    const svg = `<?xml version="1.0" encoding="UTF-8"?>
<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
     width="${width}" height="${height}" viewBox="0 0 ${width} ${height}">
  <image width="${width}" height="${height}" xlink:href="${dataURL}"/>
</svg>`;

    return svg;
  }

  downloadSVG(filename?: string): void {
    const svgContent = this.exportSVG();
    const blob = new Blob([svgContent], { type: 'image/svg+xml' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename || `drawing-${Date.now()}.svg`;
    a.click();
    URL.revokeObjectURL(url);
  }

  getDataURL(format: 'png' | 'jpeg' = 'png', quality = 0.92): string {
    const compositeCanvas = this.canvasEngine.getCompositeImage();
    return compositeCanvas.toDataURL(`image/${format}`, quality);
  }
}
